<section
  class="quote-pdf-type-modal"
  data-testid="quote-pdf-type-modal"
  aria-label="Select quote type PDF"
>
  <header class="quote-pdf-type-modal__header">
    <h3 class="quote-pdf-type-modal__title">Quote PDF</h3>
    <button
      type="button"
      class="quote-pdf-type-modal__close"
      aria-label="Close"
      (click)="onCancel()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="quote-pdf-type-modal__body">
    <p class="quote-pdf-type-modal__description">
      Please select which quote you would like to view the PDF for:
    </p>

    <div
      class="quote-pdf-type-modal__options"
      role="radiogroup"
      aria-label="Quote type options"
    >
      <mat-radio-group
        class="quote-pdf-type-modal__radio-group"
        [value]="selectedType()"
        aria-label="Quote type options"
      >
        @for (option of options(); track option.quoteType) {
          <mat-radio-button
            class="quote-pdf-type-modal__radio-option"
            [value]="option.quoteType"
            [attr.data-testid]="
              option.quoteType === 'Standard'
                ? 'quote-pdf-type-standard'
                : 'quote-pdf-type-rushed'
            "
            (change)="onSelect(option.quoteType)"
          >
            {{ option.quoteType }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  </div>

  <footer class="quote-pdf-type-modal__footer">
    <button
      type="button"
      class="btn btn-outline"
      data-testid="quote-pdf-type-cancel"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      data-testid="quote-pdf-type-confirm"
      [disabled]="!canConfirm()"
      (click)="onConfirm()"
    >
      Confirm
    </button>
  </footer>
</section>
